import { render, staticRenderFns } from "./MobileMegaMenu.vue?vue&type=template&id=60ed8f19&scoped=true&"
import script from "./MobileMegaMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileMegaMenu.vue?vue&type=style&index=0&id=60ed8f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed8f19",
  null
  
)

export default component.exports